// Auto-generated by scripts/generate-registry.mjs from packages/modules/linked_key_chain/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const linked_key_chain: ModuleSchema = {
  "id": "linked_key_chain",
  "uniqueId": "B3D_Q6S65",
  "createdAt": "2026-10-02T00:00:00Z",
  "updatedAt": "2026-10-30T10:31:13.345Z",
  "label": "Linked Chain",
  "description": "Articulated keycap clicker chain — separate modular switch blocks joined by snap-fit BALL-AND-SOCKET swivel joints. Each link clicks together once and then swings (yaw) and tilts (pitch) freely on a uniform clearance, without loading any spring.",
  "category": "fidget",
  "tags": [
    "fidget",
    "keycap",
    "chain",
    "articulated",
    "ball-joint",
    "keyboard",
    "keychain",
    "switch"
  ],
  "sliders": [
    {
      "key": "keyCount",
      "label": "Number of Keys",
      "min": 1,
      "max": 8,
      "default": 3,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "keyPitch",
      "label": "Key Block Pitch",
      "min": 20,
      "max": 28,
      "default": 24,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "switchSize",
      "label": "MX Switch Cutout Size",
      "min": 12,
      "max": 16,
      "default": 14.2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "frameHeight",
      "label": "Base Frame Height",
      "min": 12,
      "max": 28,
      "default": 18.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "cornerRadius",
      "label": "Base Frame Fillet",
      "min": 1,
      "max": 10,
      "default": 6,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keycapWidth",
      "label": "Keycap Width",
      "min": 16,
      "max": 25,
      "default": 21.5,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemClearance",
      "label": "Keycap Stem Clearance (nho = bam chat vao switch, khong can keo)",
      "min": 0,
      "max": 0.6,
      "default": 0.05,
      "step": 0.01,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "capClearance",
      "label": "Keycap to Pocket Wall Clearance (tang = nap nho lai moi ben)",
      "min": 0.25,
      "max": 0.9,
      "default": 0.7,
      "step": 0.01,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keycapHeight",
      "label": "Keycap Height",
      "min": 4,
      "max": 12,
      "default": 6,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keycapFillet",
      "label": "Keycap Corner Fillet",
      "min": 0.5,
      "max": 6,
      "default": 3.75,
      "step": 0.25,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keycapTopFillet",
      "label": "Keycap Top Edge Fillet",
      "min": 0,
      "max": 2,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pinDiameter",
      "label": "Ball Head Diameter",
      "min": 4.5,
      "max": 5.5,
      "default": 5.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "jointClearance",
      "label": "Joint Clearance - khe bi (0.48 = chuan PLA)",
      "min": 0.25,
      "max": 0.8,
      "default": 0.48,
      "step": 0.01,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "snapBite",
      "label": "Snap Bite - do sau moi hoc (nho hon = day bi vao de hon)",
      "min": 0.2,
      "max": 0.9,
      "default": 0.55,
      "step": 0.01,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "jointGap",
      "label": "Joint Gap (Bigger = More Swing)",
      "min": 2,
      "max": 8,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "linkGap",
      "label": "Chain Link Gap (0 = Assembled)",
      "min": 0,
      "max": 15,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keychainLoop",
      "label": "Keychain Loop (0/1)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "basePattern",
      "label": "Base Frame Pattern (0=Smooth, 1=Vertical Ribs)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "integerOnly": true,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopThickness",
      "label": "Loop Thickness",
      "min": 1.5,
      "max": 6,
      "default": 3,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "raisedTextHeight",
      "label": "Embossed Text Height",
      "min": 0.4,
      "max": 3,
      "default": 1.2,
      "step": 0.2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Custom Text (Per-Key Legend)",
      "default": "ZEN",
      "kind": "text",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "roboto",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "base_frame",
      "label": "Base Frame Shell (with Ball-Socket Joints)",
      "default": "#0F766E",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "switch_sim",
      "label": "Mechanical Switch Simulation",
      "default": "#DC2626",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keycap_top",
      "label": "Keycap Button",
      "default": "#F3F4F6",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "embossed_legend",
      "label": "Embossed Legend on Cap",
      "default": "#1E293B",
      "targetGroupIds": [
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_base",
      "label": "Base Frame Assembly",
      "name": "Base Frame Assembly",
      "color": "#0F766E",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base_frame",
          "label": "Base Frame Shell (with Ball-Socket Joints)",
          "name": "Base Frame Shell (with Ball-Socket Joints)",
          "groupId": 0,
          "colorKey": "base_frame",
          "defaultColor": "#0F766E",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_switch",
      "label": "Switch Simulation Assembly",
      "name": "Switch Simulation Assembly",
      "color": "#DC2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 40,
      "parts": [
        {
          "id": "switch_sim",
          "label": "Mechanical Switch Simulation",
          "name": "Mechanical Switch Simulation",
          "groupId": 1,
          "colorKey": "switch_sim",
          "defaultColor": "#DC2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": 40,
          "export_stl": false
        }
      ]
    },
    {
      "id": "obj_cap",
      "label": "Keycap Assembly",
      "name": "Keycap Assembly",
      "color": "#F3F4F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 75,
      "parts": [
        {
          "id": "keycap_top",
          "label": "Keycap Button",
          "name": "Keycap Button",
          "groupId": 2,
          "colorKey": "keycap_top",
          "defaultColor": "#F3F4F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 75,
          "export_stl": true
        },
        {
          "id": "embossed_legend",
          "label": "Embossed Legend on Cap",
          "name": "Embossed Legend on Cap",
          "groupId": 3,
          "colorKey": "embossed_legend",
          "defaultColor": "#1E293B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 100,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
